import { gateway } from "../../../gateway";
import { KanbanCategory } from "../interfaces/kanbanCategory.interface";

export const createKanbanCategoryAction = async (name: string, kanbanPageUid: string): Promise<KanbanCategory> => {
    try {
        const trimmedName = name.trim();

        if (!trimmedName) {
            throw new Error('Category name is required');
        }

        if (!kanbanPageUid) {
            throw new Error('Kanban page ID is required');
        }

        const response = await gateway.post('/kanban-categories/self', {
            name: trimmedName,
            kanbanPageUid: kanbanPageUid,
        });

        // Backend returns { status, message, data } where data is the created category
        const category = response.data?.data || response.data;

        if (!category) {
            throw new Error('Invalid response from server');
        }

        return category;
    } catch (error: any) {
        console.error('Error creating kanban category:', error);
        // Extract error message from backend response
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create kanban category';
        throw new Error(errorMessage);
    }
};